import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/app/actionTypes';
import { onAppInit } from './utils';

export default function* listenAppInit() {
  yield takeEvery(actionTypes.APP_INIT, onAppInit);
}
